/**
 * Normalize a setting value from DB/API: parse legacy JSON strings; leave objects/arrays as-is.
 * Kept free of settings/shipping imports to avoid circular module initialization.
 */
export function coerceStoredJsonValue(raw: unknown): unknown {
  if (raw == null || raw === "") return raw;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return raw;
    try {
      return JSON.parse(trimmed) as unknown;
    } catch {
      return raw;
    }
  }
  return raw;
}
